/// <reference path="../../typings/tsd.d.ts" /> 
module warsApp.services {
    export class VariableTypeService {
        public constructor(private $filter: angular.IFilterService) {

        }
        public format(input: string, variableType: Wars.Domain.Model.Codes.Enums.VariableType): string {
            let returnValue = input;

            switch (variableType) {
                case Wars.Domain.Model.Codes.Enums.VariableType.String:
                case Wars.Domain.Model.Codes.Enums.VariableType.Decimal:
                    break;
                case Wars.Domain.Model.Codes.Enums.VariableType.Code:
                    break;
                case Wars.Domain.Model.Codes.Enums.VariableType.Boolean:
                    returnValue = <any>input == true || input === "True" || input === "true" ? "Yes" : "No";
                    break;
                case Wars.Domain.Model.Codes.Enums.VariableType.Date:
                    returnValue = this.$filter('date')(this.convertStringToDate(input), 'shortDate');
                    break;
                case Wars.Domain.Model.Codes.Enums.VariableType.Status:
                    break;
                case Wars.Domain.Model.Codes.Enums.VariableType.State:
                    break;
                case Wars.Domain.Model.Codes.Enums.VariableType.DateTime:
                    returnValue = this.$filter('date')(this.convertStringToDate(input), 'short');
                    break;
                case Wars.Domain.Model.Codes.Enums.VariableType.Time:
                    returnValue = this.$filter('date')(this.convertStringToDate(input), 'shortTime');
                    break;
            }
            //console.log(returnValue);
            return returnValue;
        }

        private convertStringToDate(stringValue: string): Date {
            var d = new Date(stringValue);
            var validDate = false;
            if (Object.prototype.toString.call(d) === "[object Date]") {
                if (!isNaN(d.getTime())) {  // d.valueOf() could also work
                    validDate = true;
                }
            }
            if (validDate) {
                return d;
            }
            return null;
        }
    }
}

warsApp.registerService('VariableTypeService', ['$filter'])